import styles from './EditJourney.module.css'

const EditJourney = () => {
  return (  
    <main className={styles.container}>
      <h1>This is the EditJourney page</h1>
    </main>
  )
}

export default EditJourney
